export function getCurrentMonthFirstDay() {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-01`;
}

export function calDays(month) {
  const year = month.getFullYear(), m = month.getMonth();
  const firstDay = new Date(year, m, 1).getDay();
  const daysInMonth = new Date(year, m + 1, 0).getDate();
  return { firstDay, daysInMonth, year, m };
}

export function fmtDate(d) {
  if (!d) return "";
  return `${d.getMonth() + 1}/${d.getDate()}/${d.getFullYear()}`;
}

export function isSame(a, b) {
  return a && b && a.toDateString() === b.toDateString();
}

export function inRange(d, start, end) {
  if (!start || !end) return false;
  return d > start && d < end;
}
